import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

type BulkMessageDialogConfirmExitProps = {
  open: boolean;
  onClose: () => void;
  onCloseContinue: () => void;
};

export function BulkMessageDialogConfirmExit({
  open,
  onClose,
  onCloseContinue
}: BulkMessageDialogConfirmExitProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <Dialog open={open} onClose={onCloseContinue}>
      <DialogTitle>{translate("contactsPage.bulkMessage.confirmExitDialog.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {translate("contactsPage.bulkMessage.confirmExitDialog.description")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          {translate("contactsPage.bulkMessage.confirmExitDialog.exit")}
        </Button>
        <Button onClick={onCloseContinue}>
          {translate("contactsPage.bulkMessage.confirmExitDialog.continueEditing")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
